import settingsComponent from './settings.component';
import settingsRoute from './settings.routes';

angular.module('rym.settings', []).component('rymSettings', settingsComponent).run(settingsRoute);
